import React from 'react';
import {EventType} from "../../../store/alerts/types";
import AlertsTableContentComponent from "../AlertsTableContentComponent";
import AlertsTableTitleComponent from "../AlertsTableTitleComponent";

interface Props {
    events: EventType[],
    direction: number,
    type: string,
    onChangeSorting: (direction: number, type: string) => void,
    onSelectEvent: (event: EventType | null) => void,
    selectedEvent: EventType | null
}

const AlertTableComponent:React.FC<Props> = ({  events,
                                                 direction,
                                                 type,
                                                 onChangeSorting,
                                                 onSelectEvent,
                                                 selectedEvent
}) => {


    return (
        <div className='alerts__table'>
            <AlertsTableTitleComponent direction={direction}
                                       type={type}
                                       handler={onChangeSorting}
            />
            <AlertsTableContentComponent events={events}
                                         handler={onSelectEvent}
                                         selectedEvent={selectedEvent}
            />
        </div>
    );
};

export default AlertTableComponent;